'use client';

import React from 'react';
import ContentLoader from 'react-content-loader';

const ProductCardLoader: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <div
      className={`product-card cart-type-helium h-full overflow-hidden rounded-[24px] bg-light shadow-[3px_3px_10px_rgba(0,0,0,0.10)] ${className}`}
    >
      <ContentLoader
        speed={2}
        width="100%"
        height={350}
        viewBox="0 0 280 350"
        backgroundColor="#e0e0e0"
        foregroundColor="#cecece"
        className="w-full"
      >
        <rect x="20" y="15" rx="12" ry="12" width="240" height="120" />
        <rect x="200" y="20" rx="8" ry="8" width="60" height="20" />
        <rect x="20" y="140" rx="8" ry="8" width="100" height="16" />
        <rect x="20" y="170" rx="4" ry="4" width="220" height="14" />
        <rect x="20" y="190" rx="4" ry="4" width="180" height="12" />
        <rect x="20" y="210" rx="3" ry="3" width="160" height="10" />
        <rect x="20" y="230" rx="12" ry="12" width="130" height="24" />
        <rect x="20" y="260" rx="12" ry="12" width="180" height="24" />
        <rect x="20" y="295" rx="4" ry="4" width="80" height="10" />{' '}
        <rect x="20" y="310" rx="4" ry="4" width="100" height="14" />{' '}
        <rect x="20" y="328" rx="4" ry="4" width="120" height="10" />{' '}
        <rect x="200" y="300" rx="8" ry="8" width="60" height="30" />
      </ContentLoader>
    </div>
  );
};

export default ProductCardLoader;
